module.exports = __webpack_public_path__ + "img/photo.1d202715.svg";